import './assets/scss/index.scss';
import createApp from './app';

const getFetchVueData = async () => {
    if (window.vueData) return;

    return fetch('http://localhost:8080/vueData').then(res => res.json()).catch(() => { });
};

const init = async () =>{ 
    let vueData = await getFetchVueData();

    if (window.vueData && !vueData) {
        const decodeData = decodeURIComponent(window.vueData);

        vueData = JSON.parse(decodeData);
    }

    if (!vueData) {
        setTimeout(() => {
            const decodeData = decodeURIComponent(window.vueData);

            const { app, head } = createApp({ root: JSON.parse(decodeData) });
            app.mount('#app');
        }, 2000);
    } else {
        const { app, head } = createApp({ root: vueData });
        app.mount('#app');
    }
}

init();
